import React from 'react';
import { motion } from 'framer-motion';

const skills = [
  { name: 'JavaScript', level: 90 },
  { name: 'React', level: 85 },
  { name: 'Tailwind CSS', level: 80 },
  { name: 'Adobe Photoshop', level: 95 },
  { name: 'YouTube Thumbnail Design', level: 90 },
];

export default function Skills() {
  return (
    <section
      id="skills"
      className="min-h-screen bg-gradient-to-tr from-pink-50 via-yellow-50 to-green-50 px-6 md:px-20 py-20"
    >
      <h2 className="text-4xl font-bold text-center text-indigo-900 mb-12">Skills</h2>
      <div className="max-w-4xl mx-auto space-y-8">
        {skills.map(({ name, level }) => (
          <motion.div
            key={name}
            className="space-y-2"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex justify-between mb-1 font-semibold text-indigo-800">
              <span>{name}</span>
              <span>{level}%</span>
            </div>
            <div className="w-full bg-indigo-200 rounded-full h-6">
              <motion.div
                className="bg-indigo-600 h-6 rounded-full"
                initial={{ width: 0 }}
                whileInView={{ width: `${level}%` }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, ease: 'easeOut' }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
